import type { SiteDataDto } from '../../../models/site-api.model';

export const ALLINDEV_SITE_DATA: SiteDataDto = {
  profile: {
    name: 'ALL-IN-DEV',
    brandName: 'ALL-IN-',
    brandAccent: 'DEV',
    hero: {
      eyebrow: 'ALL-IN-DEV',
      titleLead: 'Weboldal, ami',
      titleAccent: 'nem csak úgy "van" –',
      titleAccentContinued: 'hanem',
      titleTail: 'dolgozik is a vállalkozásodért.',
      subtitle:
        'Üzleti weboldalakat, landing oldalakat és vendéglátói oldalakat készítek vállalkozóknak, Bt-knek és Kft-knek. Mobilbarát megjelenéssel, átgondolt felépítéssel és mérhető működéssel.',
      primaryCta: {
        label: 'Kérek ajánlati konzultációt',
        fragment: 'kapcsolat',
        icon: 'arrow_forward',
      },
      secondaryCta: {
        label: 'Megnézem a megoldásokat',
        fragment: 'megoldasok',
      },
      badges: [
        'Mobilbarát weboldalak',
        'Egyedi űrlapok',
        'Többnyelvű oldalak',
        'Google Analytics mérés',
        'Valós ügyfélvélemények',
        'Webfelügyelet és tárhely',
        'Saját projekt: Pacalkereső',
      ],
    },
    seo: {
      title: 'ALL-IN-DEV – Üzleti weboldalak vállalkozásoknak',
      description:
        'Weboldal, ami nem csak úgy van – hanem dolgozik is a vállalkozásodért. Mobilbarát, mérhető, karbantartható weboldalak vállalkozóknak, Bt-knek és Kft-knek.',
      ogTitle: 'ALL-IN-DEV – Üzleti weboldalak vállalkozásoknak',
      ogDescription:
        'Weboldal, ami nem csak úgy van – hanem dolgozik is a vállalkozásodért.',
    },
    navbarCtaLabel: 'Ajánlatkérés',
  },
  contactInfo: {
    email: 'info@allindev.hu',
    phone: '+36 70 754 9722',
    phoneHref: 'tel:+36707549722',
  },
  impressum: {
    companyName: 'Bencs Viktor EV.',
    address: '2040 Budaörs, Orchidea utca 7/2.',
    email: 'info@allindev.hu',
    phone: '+36 70 754 9722',
    taxNumber: '91644578-1-33',
    registrationNumber: '61635711',
    responsiblePerson: 'Bencs Viktor',
    disclaimer: 'A fenti adatok ideiglenes mintaadatok.',
  },
  theme: {
    layoutTheme: 'classic',
  },
  tenantFeatures: null,
  navigation: [
    { label: 'Megoldások', fragment: 'megoldasok' },
    { label: 'Portfólió', fragment: 'portfolio' },
    { label: 'Folyamat', fragment: 'folyamat' },
    { label: 'Árak', fragment: 'arak' },
    { label: 'Miért dolgozz velem?', fragment: 'miert-en' },
  ],
  footerNavigation: [
    { label: 'Megoldások', fragment: 'megoldasok' },
    { label: 'Portfólió', fragment: 'portfolio' },
    { label: 'Folyamat', fragment: 'folyamat' },
    { label: 'Miért dolgozz velem?', fragment: 'miert-en' },
    { label: 'Kapcsolat', fragment: 'kapcsolat' },
  ],
  trustBar: [
    { icon: 'smartphone', label: 'Mobilbarát weboldalak' },
    { icon: 'language', label: 'Többnyelvű oldalak' },
    { icon: 'credit_card', label: 'Bankkártyás fizetés' },
    { icon: 'analytics', label: 'Google Analytics mérés' },
    { icon: 'star', label: 'Valós ügyfélvélemények' },
    { icon: 'shield', label: 'Webfelügyelet és tárhely' },
    { icon: 'search', label: 'Saját projekt: Pacalkereső' },
  ],
  problem: {
    id: 'problema',
    title: 'A weboldalad jelenleg segíti az üzletedet, vagy csak ott van az interneten?',
    background: 'surface',
    items: [
      {
        icon: 'design_services',
        title: 'Elavult megjelenés',
        description:
          'A cég jobb, mint amit az oldal mutat róla. Az első benyomás a látogatás pillanatában dől el.',
      },
      {
        icon: 'smartphone',
        title: 'Gyenge mobilos élmény',
        description:
          'A látogatók többsége telefonról érkezik. Ha az oldal mobilon nehézkes, ők el is mennek.',
      },
      {
        icon: 'touch_app',
        title: 'Nincs egyértelmű kapcsolatfelvétel',
        description:
          'A látogató nem tudja, mit tegyen. Nincs egyértelmű CTA, nincs ajánlatkérési lehetőség.',
      },
      {
        icon: 'update',
        title: 'Nem naprakész az információ',
        description:
          'Régi nyitvatartás, elavult árak, régi képek vagy tartalmak – ez bizalmatlanságot kelt.',
      },
      {
        icon: 'bar_chart',
        title: 'Nincs mérés',
        description:
          'Nem látszik, hányan jönnek az oldalra, honnan érkeznek, és mit csinálnak rajta.',
      },
      {
        icon: 'support_agent',
        title: 'Nincs támogatás átadás után',
        description:
          'Nincs kihez fordulni módosítás, technikai hiba vagy tartalom frissítése esetén.',
      },
    ],
  },
  idealState: {
    id: 'idealis-allapot',
    title: 'Képzeld el, hogy a weboldalad végre rendben dolgozik helyetted.',
    background: 'white',
    pairs: [
      { before: 'Csak van egy oldal', after: 'Az oldal érdeklődőt hoz' },
      { before: 'Mobilon nehézkes', after: 'Mobilon is jól használható' },
      { before: 'Nincs adat a látogatókról', after: 'Google Analytics alapján mérhető' },
      { before: 'Elavul, nincs kinek frissíteni', after: 'Webfelügyelettel friss marad' },
    ],
    benefitsTitle: 'Így néz ki egy weboldal, ami valóban üzleti eszközként működik:',
    benefits: [
      'Telefonon is gyorsan és kényelmesen használható',
      'Az ügyfél könnyen ajánlatot kér vagy kapcsolatba lép',
      'Vendéglátásnál azonnal látszik nyitvatartás, étlap, kapcsolat',
      'Több nyelven is elérhető lehet',
      'Mérhető, honnan érkeznek az érdeklődők',
      'Webfelügyelettel hosszú távon is naprakész marad',
    ],
    cta: {
      label: 'Kérek ajánlati konzultációt',
      fragment: 'kapcsolat',
    },
  },
  solution: {
    id: 'megoldasok',
    title: 'Nem sablonoldalt készítek, hanem a vállalkozásod működéséhez illeszkedő webes megoldást.',
    background: 'dark',
    intro:
      'Először megértem, mire kell választ adnia az oldalnak: több ajánlatkérésre, vendégek tájékoztatására, bizalomépítésre vagy szolgáltatás bemutatására. Ezután ehhez tervezem meg a felépítést, a funkciókat és a működést.',
    items: [
      {
        icon: 'flag',
        title: 'Üzleti weboldal',
        description:
          'Több aloldalas bemutatkozó oldal, amely megmutatja, kik vagytok és mit csináltok. Bizalomépítés, referenciák, ajánlatkérés.',
        demoLabel: 'Megnézem az üzleti weboldal mintát',
        demoHref: 'https://onlineadmin.hu',
      },
      {
        icon: 'restaurant_menu',
        title: 'Vendéglátói weboldal',
        description:
          'Nyitvatartás, étlap, képgaléria és kapcsolatfelvétel – minden, amit a vendég keres, gyorsan megtalálva.',
        demoLabel: 'Megnézem a vendéglátói mintát',
        demoHref: 'https://etterem.pacalkereso.hu',
      },
      {
        icon: 'business',
        title: 'B2B szolgáltatói oldal',
        description:
          'Szakmai hitelességet sugárzó oldal, amely érthetően mutatja be a szolgáltatást és ajánlatkérés felé vezeti a látogatót.',
        flagKey: 'b2bPage',
      },
      {
        icon: 'ads_click',
        title: 'Komplex projekt',
        description:
          'Adatbázissal összekötött térképes keresőszolgáltatás. Integrált admin felület, vendégregisztráció.',
        demoLabel: 'Megnézem a Pacalkeresőt',
        demoHref: 'https://pacalkereso.hu',
      },
      {
        icon: 'shopping_cart',
        title: 'Webshop',
        description:
          'Termékek bemutatása és online értékesítése – kosár, fizetés, rendeléskezelés átlátható adminfelülettel.',
        flagKey: 'webshop',
      },
      {
        icon: 'build',
        title: 'Egyedi webes rendszer',
        description:
          'Adminfelület, adatkezelés, belső folyamatok, speciális keresők – ha a sablon nem elegendő, egyedi megoldást fejlesztek.',
        flagKey: 'customWebSystem',
      },
    ],
  },
  features: {
    id: 'funkciok',
    title: 'Funkciók, amelyek valóban hasznosak a látogatóidnak és neked is.',
    background: 'surface',
    items: [
      {
        icon: 'smartphone',
        title: 'Mobilbarát megjelenés',
        description: 'Telefonon, tableten és asztali gépen egyaránt jól használható, gyorsan töltődő oldal.',
      },
      {
        icon: 'credit_card',
        title: 'Bankkártyás fizetés',
        description:
          'Kényelmes, gyors és biztonságos fizetés a Stripe online fizetési rendszer bekötésével.',
        flagKey: 'cardPayment',
      },
      {
        icon: 'schedule',
        title: 'Élő nyitvatartási idő',
        description: 'Aktuális nyitva / zárva állapot megjelenítése, egyszerűen frissíthető nyitvatartással.',
      },
      {
        icon: 'translate',
        title: 'Többnyelvű oldal',
        description: 'Magyar, angol, német vagy más nyelven is elérhető oldal külön tartalmakkal.',
      },
      {
        icon: 'star_rate',
        title: 'Google Maps vélemények',
        description: 'Valós ügyfél- vagy vendégvélemények automatikus megjelenítése az oldalon.',
        flagKey: 'googleMapsReviews',
      },
      {
        icon: 'analytics',
        title: 'Google Analytics bekötés',
        description: 'Látogatottság, érdeklődői útvonalak, konverziók – mérhető adatok a döntésekhez.',
      },
      {
        icon: 'database',
        title: 'Adatkezelés és adminfelület',
        description:
          'Étlap, termékek, hírek, képek, ajánlatok kezelése saját felületen, programozói segítség nélkül.',
        flagKey: 'dataManagementAdmin',
      },
      {
        icon: 'map',
        title: 'Térképes megjelenítés',
        description: 'Interaktív térkép, útvonaltervező, több helyszín megjelenítése egy oldalon.',
        flagKey: 'mapDisplay',
      },
      {
        icon: 'photo_library',
        title: 'Galéria és referenciák',
        description: 'Munkák, vendéglátói hangulat, termékek vagy projektek képes bemutatója.',
      },
      {
        icon: 'shield',
        title: 'Webfelügyelet',
        description:
          'Tárhely, karbantartás, kisebb módosítások és frissítések gondoskodnak az oldal folyamatos működéséről.',
      },
    ],
  },
  psr: {
    id: 'esetek',
    title: 'Konkrét üzleti problémákra kínálok webes megoldást.',
    background: 'white',
    items: [
      {
        problem: 'Kevés ajánlatkérés érkezik.',
        solution: 'Átgondolt oldalfelépítés, egyértelmű CTA, ajánlatkérő űrlap, referenciák.',
        result: 'A látogató nem csak nézelődik, hanem kapcsolatba lép.',
      },
      {
        problem: 'Vendéglátóhelynél nehezen találhatók az alapinformációk.',
        solution: 'Mobilbarát oldal aktuális kínálattal, képekkel és kapcsolatfelvételi lehetőséggel.',
        result: 'A vendég gyorsabban dönt, hív vagy elindul.',
      },
      {
        problem: 'A cég komolyabb, mint amit az oldala mutat.',
        solution: 'Új, strukturált céges weboldal referenciákkal, szolgáltatás bemutatásával, ajánlatkéréssel.',
        result: 'Erősebb bizalom és jobb első benyomás.',
      },
      {
        problem: 'Sok változó adatot kell kezelni.',
        solution: 'Adatbázis-alapú működés közérthető adminfelülettel.',
        result: 'A tartalom rendezett, frissíthető és bővíthető.',
        flagKey: 'dataManagementAdmin',
      },
      {
        problem: 'Nem látszik, mit csinálnak a látogatók.',
        solution: 'Google Analytics és alap konverziós mérések bekötése.',
        result: 'Döntéseket lehet hozni adatok alapján.',
      },
      {
        problem: 'Nincs kapacitás az oldal karbantartására.',
        solution: 'Webfelügyeleti előfizetés tárhellyel, karbantartással és kisebb módosításokkal.',
        result: 'Az oldal hosszú távon is naprakész marad.',
      },
    ],
  },
  portfolio: {
    id: 'portfolio',
    title: 'Valós projektek, valós problémákra épített megoldásokkal.',
    background: 'surface',
    items: [
      {
        tag: 'Saját projekt',
        title: 'Pacalkereső',
        imageSrc: '/images/portfolio/pacalkereso-landing.jpg',
        imageAlt: 'Pacalkereső weboldal főoldal',
        problem:
          'A pacalt kínáló vendéglátóhelyek információi szétszórtan jelentek meg, a vendégek nehezen találták meg, hol érdemes keresni.',
        solution:
          'Tematikus keresőfelületet építettem, amely rendszerezi a helyeket, támogatja a mobilos használatot, és segíti a vendéglátóhelyek megtalálását.',
        proofs: [
          'Saját digitális terméket is tudunk építeni',
          'Értjük a vendéglátói piacot',
          'Keresőben és mobilos felhasználói élményben gondolkodunk',
          'Hosszú távon is működtetünk projektet',
        ],
        ctaLabel: 'Megnézem a Pacalkeresőt',
        ctaHref: 'https://pacalkereso.hu',
      },
      {
        tag: 'Vendéglátói minta',
        title: 'Éttermi weboldal',
        imageSrc: '/images/portfolio/kanyarbufe-landing.jpg',
        imageAlt: 'Kanyar Büfé éttermi mintaoldal',
        problem:
          'Egy vendéglátóhelynél a látogató főleg vizuális szempontból fog dönteni: szimpatikus a hely? Mi a kínálat? Könnyen rá tud hangolódni?',
        solution:
          'Mobilbarát oldalt készítettem, ahol meggyőző bizonyítékokkal sikerült érvelni a hely mellett.',
        proofs: [
          'Gyors, mobilbarát megjelenés',
          'Nyitvatartás és alapinformációk jól láthatóan',
          'Telefonos CTA és kapcsolatfelvétel',
          'Képgaléria a hangulat bemutatásához',
        ],
        ctaLabel: 'Megnézem a vendéglátói mintát',
        ctaHref: 'https://etterem.pacalkereso.hu',
      },
      {
        tag: 'Üzleti weboldal minta',
        title: 'Online Admin',
        imageSrc: '/images/portfolio/onlineadmin-landing.jpg',
        imageAlt: 'Online Admin üzleti mintaoldal',
        problem:
          'Egy üzleti szolgáltatásnál a látogató nem dönt azonnal. Először értenie kell a szolgáltatás értékét, és bizalmat kell kapnia.',
        solution:
          'Olyan oldalszerkezet készült, amely érthetően mutatja be a szolgáltatást, kezeli a döntési bizonytalanságot, és ajánlatkérés felé vezeti a látogatót.',
        proofs: [
          'Érthetően bemutatott szolgáltatás',
          'Bizalomépítő elemek és referenciák',
          'Döntési bizonytalanság kezelése',
          'Átgondolt ajánlatkérési folyamat',
        ],
        ctaLabel: 'Megnézem az üzleti weboldal mintát',
        ctaHref: 'https://onlineadmin.hu',
      },
    ],
  },
  serviceDirections: {
    id: 'szolgaltatasok',
    title: 'Milyen webes megoldásra lehet szükséged?',
    background: 'white',
    items: [
      {
        icon: 'ads_click',
        title: 'Landing oldal',
        description: 'Célzott egyoldalas oldal kampányhoz, ajánlatkéréshez vagy szolgáltatásbemutatáshoz.',
      },
      {
        icon: 'apartment',
        title: 'Céges weboldal',
        description: 'Több aloldalas bemutatkozó oldal vállalkozásoknak, referenciákkal és ajánlatkéréssel.',
      },
      {
        icon: 'restaurant',
        title: 'Vendéglátói weboldal',
        description: 'Kínálat, telefonos CTA, képgaléria, kapcsolatfelvétel, többnyelvűség.',
      },
      {
        icon: 'handshake',
        title: 'B2B szolgáltatói oldal',
        description: 'Szakmai bizalom, szolgáltatásbemutatás, esettanulmány és ajánlatkérési folyamat.',
        flagKey: 'b2bPage',
      },
      {
        icon: 'shopping_bag',
        title: 'Webshop',
        description: 'Termékek bemutatása és online értékesítése átlátható adminfelülettel.',
        flagKey: 'webshop',
      },
      {
        icon: 'settings_suggest',
        title: 'Egyedi webes rendszer',
        description: 'Adminfelület, adatkezelés, belső folyamatok és speciális megoldások.',
        flagKey: 'customWebSystem',
      },
    ],
    cta: {
      label: 'Kérek egyedi ajánlatot',
      fragment: 'kapcsolat',
    },
  },
  webSupervision: {
    id: 'webfelugyelet',
    title: 'Webfelügyelet: hogy az oldalad átadás után is naprakész maradjon.',
    subtitle:
      'A weboldalad története nem ér véget azzal, hogy élesedik. Webfelügyelettel segítek abban, hogy az oldal hosszú távon működőképes, friss, biztonságos és elérhető maradjon.',
    background: 'surface',
    highlightBadge: 'Legjobb ár-érték arány',
    items: [
      {
        name: 'Alap webfelügyelet',
        description: 'Az oldal biztonságos, elérhető és friss marad az alapvető karbantartás révén.',
        price: '4000 Ft / hó',
        highlight: false,
        items: ['Tárhely és domain kezelés', 'Technikai felügyelet', 'Biztonsági mentések', 'SSL Certifikátok'],
      },
      {
        name: 'Aktív webfelügyelet',
        description:
          'Az oldal naprakészen marad, kisebb módosítások és tartalom frissítések is beleférnek.',
        price: '10 000 Ft / hó',
        highlight: true,
        items: [
          'Minden az alap csomagból',
          'Kisebb tartalom módosítások',
          'Szöveg- és képcserék',
          'Adatok frissítése',
          'Google Analytics ellenőrzés',
          'Évente kód-verzió frissítés'
        ],
      },
      {
        name: 'Bővített webfelügyelet',
        description: 'Teljes körű gondozás: tartalom, technikai felügyelet és fejlesztési javaslatok.',
        highlight: false,
        items: [
          'Minden aktív csomag',
          'Rendszeres tartalom frissítések',
          'Kisebb fejlesztések',
          'Tartalmi javaslatok',
          'Havi riport és javaslatok',
        ],
        flagKey: 'extendedWebSupervision',
      },
    ],
    cta: {
      label: 'Érdekel a webfelügyelet',
      fragment: 'kapcsolat',
    },
  },
  pricing: {
    id: 'arak',
    title: 'Árak',
    background: 'white',
    items: [
      {
        icon: 'language',
        label: 'Weboldal',
        price: '150 000 Ft-tól',
        description:
          'Projektfüggő, a feladat komplexitása határozza meg a végleges árat.',
      },
      {
        icon: 'schedule',
        label: 'Óradíj',
        price: '9000 Ft',
        description: 'Kisebb módosításokra, problémamegoldásokra.',
      },
      {
        icon: 'today',
        label: 'Webfelügyelet',
        price: '4000 Ft / hó -tól',
        description: 'Mindig naprakész legyen a weboldalad.',
      },
      {
        icon: 'forum',
        label: 'Konzultáció',
        price: 'Ingyenes',
        description: 'Átbeszéljük, milyen problémára keressünk megoldást.',
        highlight: true,
      },
    ],
  },
  process: {
    id: 'folyamat',
    title: 'Átlátható folyamat, felesleges szakmai ködösítés nélkül.',
    background: 'dark',
    items: [
      {
        number: 1,
        icon: 'chat',
        title: 'Megbeszéljük az üzleti célt',
        description: 'Elmondod, mire kell az oldal, milyen problémát szeretnél megoldani.',
      },
      {
        number: 2,
        icon: 'search',
        title: 'Felmérem az igényeket',
        description: 'Megértem a célcsoportot, a konkurenciát és a meglévő helyzetet.',
      },
      {
        number: 3,
        icon: 'lightbulb',
        title: 'Javaslatot adok',
        description: 'Bemutatom, milyen irányban érdemes elindulni és miért.',
      },
      {
        number: 4,
        icon: 'architecture',
        title: 'Megtervezem az oldal struktúráját',
        description: 'Felépítés, menüpontok, tartalom elrendezése és funkciók.',
      },
      {
        number: 5,
        icon: 'code',
        title: 'Elkészítem és feltöltöm az oldalt',
        description: 'Az oldal elkészül és feltöltöm az induló tartalmakat.',
      },
      {
        number: 6,
        icon: 'devices',
        title: 'Minden eszközön tesztelve',
        description: 'Mobilon, tableten és asztali gépen is ellenőrzöm az eredményt.',
      },
      {
        number: 7,
        icon: 'rocket_launch',
        title: 'Élesítem és bekötöm a mérést',
        description: 'Az oldal élő lesz, Google Analytics bekötve.',
      },
      {
        number: 8,
        icon: 'shield',
        title: 'Webfelügyelet opcionálisan',
        description: 'Igény esetén webfelügyeletben tartom naprakészen.',
      },
    ],
  },
  quoteRequest: {
    id: 'ajanlat',
    title: 'Nincs két egyforma vállalkozás, ezért nincs sablonáras weboldal sem.',
    background: 'accent',
    body:
      'Egy weboldal ára attól függ, hány aloldalra, milyen funkciókra, mennyi tartalomra és milyen hosszú távú támogatásra van szükség. Ezért először megismerem az igényt, majd átlátható, egyedi ajánlatot adok.',
    cta: {
      label: 'Kérek egyedi ajánlatot',
      fragment: 'kapcsolat',
    },
  },
  whyUs: {
    id: 'miert-en',
    title: 'Miért érdemes velem dolgozni?',
    background: 'surface',
    items: [
      {
        icon: 'trending_up',
        title: 'Üzleti szemmel gondolkodom',
        description:
          'Nem csak weboldalt készítek – megértem, mi a tényleges üzleti cél, és ahhoz igazítom a megoldást.',
      },
      {
        icon: 'record_voice_over',
        title: 'Közérthetően kommunikáció',
        description:
          'Nem technikai zsargonban, hanem a vállalkozásod nyelvén – érthető folyamat, átlátható döntések.',
      },
      {
        icon: 'emoji_events',
        title: 'Nézd meg a saját projektemet',
        description:
          'A Pacalkereső saját fejlesztés, hosszú távra terveztem – ez bizonyíték arra, hogy nem csak ígérünk.',
      },
      {
        icon: 'restaurant',
        title: 'Vendéglátói és üzleti tapasztalat',
        description:
          'Értem a vendéglátói szektor sajátosságait és az üzleti döntési folyamatok logikáját egyaránt.',
      },
      {
        icon: 'support_agent',
        title: 'Átadás után is számíthatsz rám',
        description:
          'Webfelügyelet, karbantartás, módosítások – nem hagyom magára az oldalt az élesítés után.',
      },
      {
        icon: 'tune',
        title: 'Egyedi igényekre is tudok megoldást',
        description:
          'Nem sablonoldalt erőltetek rád, ami nem passzol. Minden megoldás az adott üzlet igényeire épül.',
      },
    ],
    cta: {
      label: 'Kérek ajánlati konzultációt',
      fragment: 'kapcsolat',
    },
  },
  faq: {
    id: 'gyik',
    title: 'Gyakori kérdések',
    background: 'white',
    items: [
      {
        question: 'Miért nincs konkrét weboldalkészítési ár?',
        answer:
          'Mert minden vállalkozás más. Egy étterem oldalának más funkciói vannak, mint egy céges bemutatkozó oldalnak. Az ár függ az aloldalak számától, a szükséges funkcióktól és a hosszú távú támogatástól. Inkább megismerem az igényt, és utána adok átlátható, személyre szabott ajánlatot.',
      },
      {
        question: 'Tudsz egyszerű bemutatkozó oldalt is készíteni?',
        answer:
          'Igen, természetesen. Nem minden vállalkozásnak kell komplex megoldás. Ha egy jól felépített, mobilbarát, megbízható bemutatkozó oldal a cél, azt is elkészítem – ugyanolyan gondossággal, mint a nagyobb projekteket.',
      },
      {
        question: 'Éttermi oldalnál milyen funkciókat tudsz megoldani?',
        answer:
          'Élő nyitvatartás megjelenítése, galéria, kínálat, kapcsolatfelvételi lehetőség és többnyelvű megjelenítés. Ezeket úgy rendezem el, hogy a vendég minél gyorsabban megkapja, amit keres.',
      },
      {
        question: 'Lesz mobilnézet?',
        answer:
          'Igen, ez alap. Minden elkészített oldal mobilbarát – telefonon, tableten és asztali gépen is jól működik és jól néz ki. A mobil nézet az elsődleges tervezési szempont.',
      },
      {
        question: 'Tudsz többnyelvű oldalt készíteni?',
        answer:
          'Igen. Az oldal elkészülhet például magyar, angol és német változatban is, külön tartalmakkal és SEO-val.',
      },
      {
        question: 'Be tudod kötni a Google Analytics-et?',
        answer:
          'Igen. Igény esetén bekötöm a Google Analytics-et, így az indulástól kezdve láthatod a látogatottságot, honnan jönnek az érdeklődők, és mit csinálnak az oldalon.',
      },
      {
        question: 'Mikor kell adatbázis vagy adminisztrációs felület?',
        answer:
          'Ha az oldalon rendszeresen frissülő tartalom van – étlap, termékek, hírek, árjegyzék, helyszínek –, akkor érdemes adminisztrációs felületet csinálni, hogy ne kelljen minden módosításhoz fejlesztőt bevonni. Az adatbázis-alapú megoldás rugalmasabb és hosszú távon olcsóbb.',
        flagKey: 'dataManagementAdmin',
      },
      {
        question: 'Mi az a webfelügyelet?',
        answer:
          'Webfelügyelet azt jelenti, hogy az átadás után is gondoskodom az oldalról: technikai karbantartás, biztonsági mentések, frissítések, kisebb módosítások és tartalomfrissítések. Így nem kell az oldallal foglalkozni, mert én törődöm vele és tartom karban.',
      },
      {
        question: 'Átadás után is tudsz segíteni?',
        answer:
          'Igen. Webfelügyeleti előfizetés nélkül is elérhető vagyok kisebb módosításokra, hibajavításra vagy fejlesztési kérdésekre. Nem hagyom magára az oldalt az élesítés után.',
      },
    ],
  },
  contact: {
    id: 'kapcsolat',
    title: 'Beszéljük meg, milyen weboldal szolgálná legjobban a vállalkozásodat.',
    subtitle:
      'Nem kell pontos technikai leírással érkezned. Elég, ha elmondod, milyen problémát szeretnél megoldani, mi pedig segítünk megtalálni a megfelelő webes irányt.',
    errorFallbackEmail: 'info@allindev.hu',
  },
};
